import React from 'react';
import Icon from '../../../components/AppIcon';

const BehavioralSafetyMetrics = ({ data }) => {
  const getSeverityColor = (type) => {
    const colorMap = {
      'Fatalities': 'var(--color-error)',
      'Lost Time Injury': 'var(--color-error)',
      'Major Injury': 'var(--color-warning)',
      'Minor Injury': 'var(--color-warning)',
      'Near Miss': 'var(--color-accent)',
      'Unsafe Acts': 'var(--color-primary)',
      'Unsafe Conditions': 'var(--color-primary)'
    };
    return colorMap?.[type] || 'var(--color-muted)';
  };

  const getIcon = (type) => {
    const iconMap = {
      'Fatalities': 'Skull',
      'Lost Time Injury': 'UserX',
      'Major Injury': 'Activity',
      'Minor Injury': 'Bandaid',
      'Near Miss': 'AlertTriangle',
      'Unsafe Acts': 'Users',
      'Unsafe Conditions': 'AlertCircle'
    };
    return iconMap?.[type] || 'Circle';
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {data?.map((metric, index) => (
        <div 
          key={index} 
          className="bg-card border border-border rounded-lg p-4 hover:shadow-md transition-all duration-200"
        >
          <div className="flex items-start justify-between mb-3">
            <div className="flex items-center gap-3">
              <div 
                className="w-10 h-10 rounded-lg flex items-center justify-center"
                style={{ backgroundColor: `${getSeverityColor(metric?.type)}20` }}
              >
                <Icon 
                  name={getIcon(metric?.type)} 
                  size={20} 
                  color={getSeverityColor(metric?.type)} 
                />
              </div>
            </div>
            {metric?.trend && (
              <div className={`flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${
                metric?.trendDirection === 'down' 
                  ? 'bg-success/10 text-success' :'bg-error/10 text-error'
              }`}>
                <Icon 
                  name={metric?.trendDirection === 'down' ? 'TrendingDown' : 'TrendingUp'} 
                  size={12} 
                />
                <span>{metric?.trendValue}</span>
              </div>
            )}
          </div>
          
          <div>
            <p className="text-xs text-muted-foreground mb-1">{metric?.type}</p>
            <p className="text-2xl font-bold text-foreground">{metric?.count}</p>
            <p className="text-xs text-muted-foreground mt-1">
              {metric?.period || 'Last 30 days'}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BehavioralSafetyMetrics;